import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet'
import { projectImages } from '../strings';
import { VscTypeHierarchySub } from 'react-icons/vsc'
import { GiPoolTriangle, GiWallet } from 'react-icons/gi'
import { GoLink } from 'react-icons/go'
import { IoMdCube } from 'react-icons/io'
import './themes/blockchainCrypto.css'

const title = 'Blockchain and Cryptocurrency'
const techs = [
  { name: 'React', img: '/images/icons/react-original.svg' },
  { name: 'GUN', img: '/images/icons/gun.svg' },
  { name: 'Express', img: '/images/icons/express.png' }
]

const resources = [
  '/images/icons/github.svg',
]
export default function BlockchainCrypto() {

  useEffect(() => {
    document.getElementsByTagName('body')[0].className = 'theme-blockchainCrypto'
  }, [])

  return (<>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <div className="App">
      <header className="App-header">
        <section className='my-10 px-3 w-full max-w-[1800px]'>
          <header className='text-2xl font-bold pt-10 text-center'>
            <h2>{title}</h2>
            <div className='project-date'>May, 2022</div>
          </header>
          <div className='my-7 space-y-24'>
            <article className='flex flex-wrap md:justify-center md:items-center'>
              <picture className='w-full md:w-6/12 shadow-lg '>
                <img src={projectImages.blockchainCrypto.preview} alt='' className='rounded-lg' />
              </picture>
              <div className='flex flex-col overflow-unset  space-y-3 my-3 mx-1 w-full md:w-5/12 '>
                <p className='shadow-lg'>
                  A group project to simulate how cryptocurrencies work with blockchain technology to perform, validate, and record transactions in a decentralized network.
                  <br /><br />
                  Topics covered:
                  <li><a href={'#sha'}>SHA-256 function</a></li>
                  <li><a href={'#dn'}>Decentralized network</a></li>
                  <li><a href={'#block'}>Block & Proof of Work (PoW)</a></li>
                  <li><a href={'#mempool'}>Mempool</a></li>
                  <li><a href={'#merkle'}>Merkle Root calculation</a></li>
                  <li><a href={'#utxo'}>Unspent Transaction Output (UTXO)</a></li>
                  <li><a href={'#bcS'}>Blockchain Structure</a></li>
                  <li><a href={'#wallet'}>Wallet</a></li>
                  <br />
                  {/* A group project with <a href='' target='_blank' rel='noreferrer'>Charitha</a>, <a href='' target='_blank' rel='noreferrer'>Dhriti</a>, and <a href='https://www.linkedin.com/in/sudeep-thokachilu' target='_blank' rel='noreferrer'>Sudeep</a>. */}
                </p>
              </div>
            </article>
          </div>

          <header className='text-2xl font-bold pt-10' id='sha'>
            <h4 className='project-header'><span>🗝️ SHA-256 function</span></h4>
          </header>
          <article className='text-left'>
            <p>
              <div className='code'>
                <div>import sha256 from 'crypto-js/sha256';</div>
                <div>const hash = sha256(nonce + message + timestamp + ...);</div>
              </div>
              SHA-256 is a one-way hashing function (cannot be reversed).<br />
              We use <a href='https://github.com/brix/crypto-js' target={'_blank'} rel='noreferrer'>crypto-js</a> (a JavaScript library for crypto standards) to obtain the hash value of:
              <li>Block</li>
              <li>Transaction</li>
              <li>Merkle Root</li>
            </p>
          </article>

          <header className='text-2xl font-bold pt-10' id='dn'>
            <h4 className='project-header'><span>🌐 Decentralized network</span></h4>
          </header>
          <article className='text-left'>
            <p>
              To achieve decentralization, we use <a href='https://github.com/amark/gun' target={'_blank'} rel='noreferrer'>Gun.js</a> (a real-time, decentralized, offline first, graph database).
              <div className='code'>
                <div>const Gun = require('gun');<br />
                  const app = express();<br />
                  require('gun/sea');<br />
                  app.use(Gun.serve);</div>
                <div>{`const gun = Gun({peers: ['http://localhost:3030/gun',...]})`}</div>
              </div>
              <a href='https://gun.eco/docs/Service-Discovery' target={'_blank'} rel='noreferrer'>
                <img src='/images/projects/BlockchainCrypto/peers.jpg' />
              </a>
              Please note that we've used public space approach on this project. We advice you try Frozen space - refer to <a
                href='https://gun.eco/docs/Content-Addressing' target={'_blank'} rel='noreferrer'
              >Gun.eco/docs/Content-Addressing</a>
            </p>
          </article>

          <header className='text-2xl font-bold pt-10' id='block'>
            <h4 className='project-header'><span><IoMdCube style={{ display: 'inherit' }} /> Block</span></h4>
          </header>
          <div className='my-7 space-y-24'>
            <article className='flex flex-wrap md:justify-center md:items-center'>
              <picture className='w-full md:w-6/12 shadow-lg'>
                <img src='/images/projects/BlockchainCrypto/blockOverview.png' alt='' className='rounded-lg' />
              </picture>
              <div className='flex flex-col overflow-unset  space-y-3 my-3 mx-1 w-full md:w-5/12 '>
                <p className='shadow-lg'>
                  In this project, we have three types of blocks:
                  <li><b>Genesis Block:</b> The first block in a blockchain. Since each block in a blockchain must have the hash of the previous block, genesis block has 0s as its previous block's hash</li>
                  <li><a href={'#validBlock'}><b>Valid Blocks:</b></a> All blocks that have been mined and added to the blockchain</li>
                  <li><a href={'#candidateBlock'}><b>Candidate Block:</b></a> Each miner (mining node) has its own candidate block</li>
                  <br />
                  Note: We did not implement <a
                    href='https://www.investopedia.com/terms/o/orphan-block-cryptocurrency.asp#:~:text=An%20orphan%20block%20is%20a,the%20shorter%20chain%20are%20orphaned.' target={'_blank'} rel='noreferrer'
                  >Orphan Block</a>
                </p>
              </div>
              <div className='w-full'>
                <header className='text-2xl font-bold pt-10' id='validBlock'>
                  <h4 className='project-header'><span>➠ Valid Block</span></h4>
                </header>
                <article className='text-left'>
                  <p>
                    <img src='/images/projects/BlockchainCrypto/block.jpg' />
                    <li><b>Confirmations:</b> (Recent block height - block height) + 1</li>
                    The confirmation value of a block increases for each new block height added to the blockchain.
                    <li><b>Difficulty:</b> We've used an integer to demonstrate the target number of starting 0s miners need to produce as their candidate block's hash before broadcasting.</li>
                    <div className='code'>
                      <div>
                        function checkDifficulty(hash, DIFFICULTY) {'{'}<br />
                        return hash.substr(0, DIFFICULTY) === "0".repeat(DIFFICULTY)<br />
                        {'}'}
                      </div>
                    </div>
                    <li><b>Block Reward:</b> Mining reward + total fees (from block transactions)</li>
                  </p>
                </article>
                <header className='text-2xl font-bold pt-10' id='candidateBlock'>
                  <h4 className='project-header'><span>➠ Candidate Block</span></h4>
                </header>
                <div className='my-7 space-y-24'>
                  <article className='flex flex-wrap md:justify-center md:items-center'>
                    <picture className='w-full md:w-6/12 shadow-lg'>
                      <img src='/images/projects/BlockchainCrypto/candidateBlock.jpg' />
                    </picture>
                    <div className='flex flex-col overflow-unset  space-y-3 my-3 mx-1 w-full md:w-5/12 '>
                      <img src='/images/projects/BlockchainCrypto/candidateBlockSolved.jpg' />
                    </div>
                    <p>
                      A miner adds unconfirmed transactions (from the <a href={'#mempool'}>mempool</a>) to his/her block, obtain merkle root, perform hashing function with different nonce value until a valid block hash value (in our case: number of starting 0s) is produced, and then broadcast the block to all nodes in the network (to be added to the blockchain).
                      <br />
                      <li>The broadcasted block gets added to the blockchain when more than 50% of the validating nodes validates the block.</li>
                      <img src='/images/projects/BlockchainCrypto/pendingBlocks.jpg' />
                      When the block is added to the blockchain, all validating nodes updates its copy of the blockchain data to reflect the recent mined block, and the miner gets the block reward.
                    </p>
                  </article>

                </div>

              </div>
            </article>
          </div>

          <header className='text-2xl font-bold pt-10' id='mempool'>
            <h4 className='project-header'><span><GiPoolTriangle style={{ display: 'inherit' }} /> Mempool</span></h4>
          </header>
          <article className='text-left'>
            <p>
              This is where all unconfirmed transactions wait to be confirmed.<br />
              For a transaction to be confirmed, the transaction needs to be included in a <a href={'#validBlock'}>valid block</a>.
              <img src='/images/projects/BlockchainCrypto/unconfirmedTXS.jpg' />
            </p>
          </article>

          <header className='text-2xl font-bold pt-10' id='merkle'>
            <h4 className='project-header'><span><VscTypeHierarchySub style={{ display: 'inherit' }} /> Merkle Root calculation</span></h4>
          </header>
          <article className='text-left'>
            <p>
              Merkle Root is obtained by hashing pairs of nodes repeatedly until only one hash remains.<br />
              The hash value of each transaction in a candidate block is pushed into an array. The array is then passed as argument to the calculateMerkleRoot function - which returns a single hash value (merkle root)
              <img src='/images/projects/BlockchainCrypto/merkleRoot.png' />
              <div className='code'>
                <div>
                  function calculateMerkleRoot(tx) {`{`}<br />
                  if (tx.length === 1)<br />
                  return tx[0];<br />
                  if (tx.length % 2 !== 0)<br />
                  tx.push(tx[tx.length - 1]);</div>
                <div>let txTemp = [];<br />
                  let i = 0;<br />
                  {`while (i < tx.length - 1)`}<br />
                  txTemp.push(sha256(tx[i] + tx[i + 1]).toString());<br />
                  i += 2;
                </div>
                <div>const merkleRoot = calculateMerkleRoot(txTemp);<br />
                  return merkleRoot;<br />
                  {`}`}
                </div>
              </div>
            </p>
          </article>

          <header className='text-2xl font-bold pt-10' id='utxo'>
            <h4 className='project-header'><span><VscTypeHierarchySub style={{ display: 'inherit' }} /> Unspent Transaction Output (UTXO)</span></h4>
          </header>
          <article className='text-left'>
            <p>
              An unspent transaction output (UTXO) refers to a transaction output that can be used as input in a new transaction. Refer to <a
                href='https://academy.binance.com/en/glossary/unspent-transaction-output-utxo' target={'_blank'} rel='noreferrer'
              >Binance Academy</a> and <a
                href='https://www.investopedia.com/terms/u/utxo.asp' target={'_blank'} rel='noreferrer'
              >Investopedia</a>
            </p>
          </article>

          <header className='text-2xl font-bold pt-10' id='bcS'>
            <h4 className='project-header'><span><GoLink style={{ display: 'inherit' }} /> Blockchain Structure</span></h4>
          </header>
          <article className='text-left'>
            <p>
              <div className='code'>
                blocks: {'{'}<br />
                0: {'{'}....{'}'},<br />
                1: {'{'}....{'}'},<br />
                .<br />
                .<br />
                n: {'{'}....{'}'}<br />
                {'}'}
              </div>
              The above is how we've structured our blockchain data.<br />
              We've used the block height as the block's key (0,1,...,n), but we do recommend you use the block hash as its key.<br />
              example:
              <div className='code'>
                blocks: {'{'}<br />
                00004624874gsdgh....: {'{'}....{'}'},<br />
                0000f8748796rdfv....: {'{'}....{'}'},<br />
                .<br />
                .<br />
                0000xcf6ewth75l8....: {'{'}....{'}'}<br />
                {'}'}
              </div>
            </p>
          </article>

          <header className='text-2xl font-bold pt-10' id='wallet'>
            <h4 className='project-header'><span><GiWallet style={{ display: 'inherit' }} /> Wallet</span></h4>
          </header>
          <article className='text-left'>
            <p>
              <img src='/images/projects/BlockchainCrypto/dashboard.jpg' />
              Wallet tab shows the user's account type (miner or normal), crypto balance (Rhyme Coin) and its equivalent in fiat currency, and the user's address.
              <li>Using <a href='http://www.floatrates.com/daily/usd.json' target={'_blank'} rel='noreferrer'>
                floatrates USD JSON feed</a>, we were able to allow users display their fiat amount in multiple currencies</li>
              Note: We've used the users' public key as their public address (Pay-to-PubKey (P2PK)). The users' public address can also be the hash of the users' public key (Pay-to-PubKey-Hash (P2PKH)).
              <br />
              <br />
              <img src='/images/projects/BlockchainCrypto/dashboardTXS.jpg' />
              Transactions tab shows all transactions associated with the user's public key.
            </p>
          </article>

          <header className='text-2xl font-bold pt-10'>
            <h4 className='project-header'><span>⚙️ Tools and Technologies</span></h4>
          </header>
          <article className='text-left'>
            <p>
              <div className="flex mb-[5px]">
                {techs.map((tech, index) => (
                  <button
                    style={{
                      cursor: 'default',
                      background: `url(${tech.img})`,
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 30,
                      marginRight: 10,
                      width: 30, height: 30, borderRadius: '50%'
                    }} key={index}></button>
                ))}
              </div>
              {techs.map((tech, index) => (
                <li key={index}>{tech.name}</li>
              ))}
            </p>
          </article>

          <header className='text-2xl font-bold pt-10'>
            <h4 className='project-header'><span>🔗 Resources</span></h4>
          </header>
          <article className='text-left'>
            <p>
              <div className="flex mb-[5px]">
                {resources.map((tech, index) => (
                  <button
                    style={{
                      cursor: 'default',
                      background: `url(${tech})`,
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 30,
                      marginRight: 10,
                      width: 30, height: 30, borderRadius: '50%'
                    }} key={index}></button>
                ))}
              </div>
              {/* <li>Source code: <a href='https://github.com/33yliam/Blockchain-and-Cryptocurrency' target='_blank' rel='noreferrer'>GitHub code</a></li>
              <li>Source code: <a href='' target='_blank' rel='noreferrer'>PPT Presentation</a></li> */}
              <li>Project report: <a href='/projects/bc-cpt.pdf' rel='noreferrer'>Report (PDF)</a></li>
              {/* <li>Source code: loading...</li> */}
            </p>
          </article>


        </section>
      </header >
    </div >
  </>)
};